/* eslint-disable no-undef */
function searchOpen() {
  $('.hamburger').removeClass('is-active')
  $('.toolbar__links').removeClass('is-open')
  $('.search-overlay').css('opacity', 1)
  $('.search-overlay').css('pointer-events', 'auto')
  $('.search-input').focus()
  $('body').addClass('search-open')
}

function searchClose() {
  $('body').removeClass('search-open')
  $('.search-overlay').css('opacity', 0)
  $('.search-overlay').css('pointer-events', 'none')
}

$(function () {
  $('.js-nav').off()
  $(document).on('click', '.js-nav', function () {
    if ($(this).hasClass('is-active')) {
      $('.hamburger').removeClass('is-active')
      $('.toolbar__links').removeClass('is-open')
    } else {
      $('.toolbar__links').removeClass('no-transition')
      $('.hamburger').addClass('is-active')
      $('.toolbar__links').addClass('is-open')
      searchClose()
    }
    return false
  })

  $('.js-search-open').on('click', function () {
    if ($('body').hasClass('search-open')) {
      searchClose()
    } else {
      searchOpen()
    }
    return false
  })

  $('.js-search-close').on('click', function () {
    searchClose()
    return false
  })
})
